<template>
  <div class="f14-l19 df18-l23  h-100">
    <div class="d-flex flex-column h-100" :class="alignment">
      <div class="align-items-center d-flex flex-row position-relative" :class="alignment2">
        <img src="@/assets/currency_icon.svg" class="spacer-left-small" style="width:17px; height:46px" />
        <div class="accordion-header pointer" @click="showPopup">{{details.display.price.label_text}}
          {{details.display.minimum_order_price}}
        </div>
        <CaretComponent :open="popupVisible" @click="showPopup" />
        <div v-show="popupVisible">
          <div class="d-flex flex-column innerpopup ">
            <div class="nowrap" v-if="details.minimum_order_price_for.carrier_delivery.available">
              {{details.minimum_order_price_for.carrier_delivery.label_text}}
              {{details.minimum_order_price_for.carrier_delivery.minimum_order_price}}
            </div>
            <div class="nowrap" v-if="details.minimum_order_price_for.self_pickup.available">
              {{details.minimum_order_price_for.self_pickup.label_text}}
              {{details.minimum_order_price_for.self_pickup.minimum_order_price}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <BGClickCatcherComponent v-show="popupVisible" @click="showPopup" />
  </div>
</template>
<script>
import CaretComponent from "@/components/CaretComponent";
import BGClickCatcherComponent from "@/components/popup/BGClickCatcherComponent";
// import SvgImage from "@/components/generic/SvgImage";
export default {
  components: {
    // SvgImage,
    CaretComponent,
    BGClickCatcherComponent
  },
  data() {
    return {
      popupVisible: false,
      showit: false
    }
  },
  props: {
    details: Object
  },
  methods: {
    showPopup() {
      this.popupVisible = !this.popupVisible;
    },
  },
  computed: {
    alignment() {
      if (this.$isDesktop()) {
        return "justify-content-center align-items-center";
      }
      return "align-items-right";
    },
    alignment2() {
      return this.$isDesktop() ? "justify-content-center" : "";
    }
  }
}
</script>
<style scoped>
.asmessage {
  border: 1px solid #bbbaba;
  border-radius: 20px;
  background: white;
  margin-left: 5px;
  display: inline-block;
  text-align: center;
  color: #171717;
  text-decoration: none;
  padding: 0 5px 0 5px;
}

.innerpopup {
  z-index: 4000;
  background: white;
  position: absolute;
  right: 0;
  top: 40px;
  border: 1px solid #ccc;
  padding: 20px 20px;
}

.carousel .innerpopup {
  top: inherit;
  bottom: 25px;
}

.small-space {
  margin-right: 5px;
}
</style>